module.exports = __webpack_public_path__ + "img/uzb.eb1e00b8.svg";